/* eslint-disable react/prefer-stateless-function */
import * as React from 'react';
import shallowEqual from 'utils/shallowEqual';
import cx from 'classnames';
import styles from './Card.css';
// Note: There are parts in the codebase where refs are added on Card
// component. If this is made into a stateless component, those ref accesses
// will fail. Until they are removed, this should not be changed to a stateless
// component.
export default class Card extends React.Component {
    shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
    }
    render() {
        return (<div ref={this.props.innerRef} className={cx(styles['card'], this.props.className)} style={this.props.style} onClick={this.props.onClick}>
				{this.props.children}
			</div>);
    }
}
